import React, { useEffect, useState } from "react";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import Table from "../../../components/tables/Table";
import { toast } from "react-toastify";
import CustomLoading from "../../../components/customLoading/CustomLoading";
import { getClinicPatientPdfs } from "../../../services/new_clinic/clinic_doctor_view";
import { formatDateTime } from "../../../utils/FormatDateTime";
import { BsEye } from "react-icons/bs";
import CustomPDFViewer from "../../../components/PdfViewer/CustomPdfViewer";

const NewPatientDoctorPdfView = ({ patientId }) => {
    const [loading, setLoading] = useState(false);
    const headers = [
        { label: "S. No.", key: "i" },
        { label: "Pdf", key: "pdf" },
        { label: "Date", key: "updated_at" },
    ];

    const [selectedPdf, setSelectedPdf] = useState(null);

    const [tableData, setTableData] = useState([]);

    const fetchTabletData = async (patientId) => {
        try {
            let res = await getClinicPatientPdfs(patientId);
            if (res.status === 200) {
                setTableData(res.data.results);
            } else {
                toast.error("Unable to fetch data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTabletData(patientId);
    }, [patientId]);


    return (
        loading ? <CustomLoading /> :
            <>
                <div className="w-full flex-1">
                    <StyledHeadingText text={"PATIENT PDFs"} size={"mb-2"} />
                    <div className="flex md:flex-row gap-2">
                        <div className={`w-full ${selectedPdf ? "max-w-md" : ""}`}>
                            <Table
                                headers={headers}
                                rows={tableData.map((item, index) => {
                                    return {
                                        i: String(index + 1),
                                        updated_at: formatDateTime(item.updated_at),
                                        pdf: <BsEye className="text-primary font-bold text-lg cursor-pointer" onClick={() => { setSelectedPdf(item.pdf) }} />
                                    };
                                })}
                            />
                        </div>
                        {
                            selectedPdf &&
                            <div className="w-full max-h-[75vh] overflow-auto">
                                <CustomPDFViewer pdfUrl={selectedPdf} />
                            </div>
                        }
                    </div>
                </div >
            </>
    );
};

export default NewPatientDoctorPdfView;
